// @flow
import React from 'react';
import browserNotSupported from 'assets/images/noSupport.png';

import './styles.scss';

export const BrowserSupport = () => {
  return (
    <div className={'browser-support'}>
      <img src={browserNotSupported} alt={'Browser Not Supported'} />
      <h1>Browser not supported</h1>
      <h2>
        Use Safari, Google Chrome or Microsoft Edge to experience Total
        Environment
      </h2>
    </div>
  );
};
